import RetainOverlayTrigger from "Components/RetainOverlayTrigger";
import React from "react";
import { Card } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { StellaSoraPotential } from "Views/StellaSora/Models";
type TTrigger = "click" | "hover" | "focus";
interface IPotentialIconProps {
	pot: StellaSoraPotential;
	level?: number;
	plus?: boolean;
	trigger?: TTrigger[]
	disableTooltip?: boolean;
}
export default function PotentialCard({pot, level, plus, disableTooltip, trigger}: IPotentialIconProps) {
	const ratio = 230/180;
	const width = 130;
	level = Math.min(level ?? 1, pot.maxLevel)
	// const width = 180;
	const height = width*ratio;
	const PotCard = (<Card key={pot.id} tabIndex={0} className="pot" style={{backgroundImage: `url(${pot.getBackground()})`, overflow: "hidden", backgroundRepeat: "no-repeat", backgroundSize: `${width}px ${height}px`, width, height, textAlign: "center"}}>
			<Card.Header className="" style={{color: "black", lineHeight: 0,
				height: "1em", marginTop:0, marginBottom: "auto", padding: "8% 0px 0px 10%", textAlign: "left"}}>
				{level}{plus && "+"}
			</Card.Header>
			<Card.Body><img src={pot.getIcon()} alt={pot.id.toString()} style={{width: width*.8, height: width*.8, marginTop: "-18%", 
				marginBottom:0,marginLeft: "auto", marginRight: "auto", backgroundImage: pot.corner ? `url(${pot.getCorner()})` : undefined, backgroundRepeat:"no-repeat", backgroundSize: "contain", }} /></Card.Body>
			<Card.Footer className="" style={{color: "black", lineHeight: 1,  marginTop:"auto", marginBottom: 0,
			padding:0
			
				
			}}><Card.Text style={{height: "2em", width: "95%", paddingTop: 0, marginTop: 0, marginBottom: "auto", marginLeft: "auto", marginRight: "auto"}}>{pot.name}</Card.Text></Card.Footer>
		</Card>);
	if (disableTooltip) {
		return PotCard;
	}
	return (
		<RetainOverlayTrigger trigger={trigger} overlay={(<ReactMarkdown>{`#### ${pot.name} Lv.${level??1}/${pot.maxLevel}\n\n${pot.getDescription(level)}`}</ReactMarkdown>)}>
			{PotCard}
		</RetainOverlayTrigger>
	);
}